var DEFAULT_PERFECT_SCROLLBAR_CONFIG = {
// suppressScrollX: true
};
var ɵ0 = DEFAULT_PERFECT_SCROLLBAR_CONFIG;
var LayoutModule = /** @class */ (function () {
    function LayoutModule() {
    }
    return LayoutModule;
}());
export { LayoutModule };
export { ɵ0 };
